import { setCountryCookie } from '../helpers/localization';
import setTokensOnLocalStorage from '../helpers/setTokensOnLocalStorage';
import redirect from './helpers/redirect';
import { setLocalTokens } from './tokens';

export const SET_POPOVER = 'SET_POPOVER';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';
export const DO_LOGOUT = 'DO_LOGOUT';

const setLoggedIn = () => ({ type: SET_LOGGED_IN });
const setNotificationCount = (value) => ({
  type: SET_NOTIFICATION_COUNT,
  value,
});
const setPopover = (value) => ({ type: SET_POPOVER, value });
const logout = () => ({ type: DO_LOGOUT });

const handleLoginResponse = (response) => (dispatch) => {
  dispatch(setLocalTokens(response));
  setTokensOnLocalStorage(response);
  setCountryCookie(response.country);
  dispatch(setLoggedIn());
  return dispatch(redirect());
};

export {
  handleLoginResponse,
  logout,
  setLoggedIn,
  setPopover,
  setNotificationCount,
};
